import { call, put, takeLatest } from "redux-saga/effects";

import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import api from "service/apiService";
import { ApiResponse } from "types";
import { translate } from "utils";
import {
	GetSurveyPayload,
	GetSurveysAsyncPayload,
	getSurveyDetailAsync,
	getSurveysAsync,
	setSurvey,
	setSurveys,
	updateSurveyAsync,
} from "./survey.slice";
import { Survey } from "../types";

// Get list contact supports
function* getSurveysSaga(action: PayloadAction<GetSurveysAsyncPayload>) {
	const { query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<Survey[]>>(
				"/surveys",
				{ ...query, skip: query.skip },
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({
			type: setSurveys.type,
			payload: { data: response.data, total: response.total },
		});
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetSurveys() {
	yield takeLatest(getSurveysAsync, getSurveysSaga);
}

// Get contact support details
function* getSurveyDetailsSaga(action: PayloadAction<GetSurveyPayload>) {
	const { id, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<Survey>>(
				`/dashboard/customer-requests/${id}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setSurvey.type, payload: response });
		callback?.();
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetSurveyDetail() {
	yield takeLatest(getSurveyDetailAsync, getSurveyDetailsSaga);
}

// Update contact support details
function* updateContactSupportSaga(action: PayloadAction<any>) {
	const { _id } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			if (_id) {
				const { data: response } = await api.put(
					`/surveys/${_id}`,
					action.payload,
				);
				return { response };
			} else {
				const { data: response } = await api.post(`/surveys`, action.payload);
				return { response };
			}
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		// yield put({ type: getContactSupportDetailsAsync.type, payload: response });
		// message.success(translate("Update successful"));
		// callback?.();
	} else {
		// message.error(translate(error.message));
	}
}

function* watchUpdateContactSupport() {
	yield takeLatest(updateSurveyAsync, updateContactSupportSaga);
}

const surveySaga = [
	watchGetSurveys(),
	watchGetSurveyDetail(),
	watchUpdateContactSupport(),
];
export default surveySaga;
